"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompletedEpochPaginatedListSchema = exports.CurrentEpochSchema = exports.CompletedEpochSchema = exports.EpochSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
exports.EpochSchema = zod_1.z.object({
    id: zod_1.z.string({ required_error: 'id is required' }),
    epochID: zod_1.z.number().int().min(0),
    startDate: zod_1.z.string().datetime(), // ISO 8601
    endDate: zod_1.z.string().datetime().optional().nullable(), // ISO 8601
    tvl: core_contracts_ifaces_1.TokenAmountSchema,
    totalCollectedFees: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    apr: zod_1.z.number(),
    collectedFees: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
});
exports.CompletedEpochSchema = exports.EpochSchema;
exports.CurrentEpochSchema = exports.EpochSchema;
exports.CompletedEpochPaginatedListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.CompletedEpochSchema),
    metadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
